<template>
	<div style="background-color:#F0F0F0;">

        <v-toolbar flat fixed>
            <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
            <v-toolbar-title class="white--text">Data Backups</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu>
                <v-btn slot="activator" icon><v-icon>more_horiz</v-icon></v-btn>
                <v-list dense nopadding>
                    <v-list-tile @click="fn_getChunks">
                        <v-list-tile-title>View Chunks</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
        </v-toolbar>

        <div class="hasToolbar full-height">
            
            <v-list two-line nopadding>

                <div v-for="(item, index) in items" :key="index">
                    <v-list-tile>
                        <v-list-tile-action v-if="fn_deleteAction(item, index)">
                            <v-btn icon @click="fn_archiveItem(item.id, index)"><v-icon>delete</v-icon></v-btn>
                        </v-list-tile-action>
                        
                        <v-list-tile-content v-ripple>
                            <v-list-tile-title>{{item.localName}}</v-list-tile-title>
                            <v-list-tile-sub-title>Created On: {{item.createdTimeString}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                            <v-menu>
                              <v-btn slot="activator" icon>
                                <v-icon>more_horiz</v-icon>
                              </v-btn>
                              <v-list nopadding>
                                <v-list-tile @click="fn_backupAllBusinessData(item)">
                                  <v-list-tile-title>Restore</v-list-tile-title>
                                </v-list-tile>
                              </v-list>
                            </v-menu>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="items && items.length-1 != index"></v-divider>
                </div>

            </v-list>

            <div v-if="!items.length" class="display_msg">No Data Backups!</div>
        </div>

        <v-dialog v-model="chunkItemsDialog" no-click-animation persistent scrollable fullscreen content-class="full-height" lazy transition="dialog-bottom-transition">

            <v-card>
                <v-toolbar flat>
                    <v-toolbar-side-icon @click="chunkItemsDialog=false"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
                    <v-toolbar-title class="white--text">Chunk Items</v-toolbar-title>
                </v-toolbar>

                <v-card-text full-height nopadding grey-back>
                    <v-list three-line nopadding>
                        <div v-for="(item, index) in chunkItems" :key="index">
                            <v-list-tile>
                                <v-list-tile-content v-ripple>
                                    <v-list-tile-title>{{item.localName}}</v-list-tile-title>
                                    <v-list-tile-sub-title>Created On: {{item.createdTimeString}}</v-list-tile-sub-title>
                                    <v-list-tile-sub-title v-if="item.trashed" redcolor>Trashed</v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-divider v-if="chunkItems && chunkItems.length-1 != index"></v-divider>
                        </div>
                    </v-list>

                    <div class="pa-3 center-align light-opacity-color" v-if="!chunkItems.length">No chunks available</div>
                </v-card-text>
            </v-card>	
            </v-dialog>

	</div>
</template>

<script>

    export default{

        data(){
            return{
                items:[],
                chunkItems:[],
                chunkItemsDialog:false
            }
        },

        methods:{
            fn_goBack: function(){
                this.$router.go(-1);
            },

            fn_getBackups: function(){
                let self = this;
                this.showLoading("Please wait...");
                this.getData('ComplexFiles', this.$root.CurrentBusiness.BusinessID, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            let data = JSON.parse(response);
                            self.items = data && data.fileList ? data.fileList : [];
                            // converting milliseconds to date time string and appenind to obj
                            for(let i=0; i<self.items.length; i++){
                                self.items[i].createdTimeString = self.$moment(self.items[i].createdTime.value).format('DD-MMM-YYYY h:mm a');

                            }
                            self.hideLoading();
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.hideLoading();
                        }
                    }
                );
            },

            fn_archiveItem: function(itemId, index){
                let self = this;
                this.showLoading("Database archive...");
                this.getData('DeleteComplexBackup', itemId, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.items.splice(index, 1);
                            self.hideLoading();
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.hideLoading();
                        }
                    }
                );
            },

            fn_backupAllBusinessData: function(item){

                let self = this;
                let filterObject = {}
                filterObject.complexOperation = false;

                // this.showLoading('Configuring backup drive...');

                this.showLoading("Please wait...");

                this.getFilterData('BackupAllData', this.$root.CurrentBusiness.BusinessID, filterObject,
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.fn_restoreData(item);
                            // self.hideLoading();
                            // self.showToast('Data backup complete');
                            // self.fn_reopenDatabase(dataDrive);
                        },
                        onError: function(error){
                            console.log(error);
                            self.hideLoading();
                            self.fn_reopenDB();
                            self.showToast('Something went wrong. Try again');
                        }
                    }
                );
                
            },

            fn_restoreData: function(item){
                let self = this;

                let postObj = {};
                postObj.id = item.id;
                postObj.businessId = this.$root.CurrentBusiness.BusinessID;
                postObj.name = item.name;
                postObj.modifiedTime = item.modifiedTime;
                postObj.size = item.size;
                postObj.createdTime = item.createdTime;
                postObj.description = item.description;

                // this.showLoading("Please wait...");
                this.postData('RestoreComplexDatabase', postObj, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.showToast("Database restored");
                            self.fn_reopenDB(item.modifiedTime.value);
                            self.hideLoading();
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.fn_reopenDB();
                            self.showToast("Something went wrong. Try again");
                            self.hideLoading();
                        }
                    }
                );
            },

            fn_reopenDB: function(modifiedTime){
                let self = this;
                this.getData('ReopenDataBase', this.$root.CurrentBusiness.BusinessID, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            console.log("Restore Complete");
                            self.fn_toggleDataShare();
                            if(modifiedTime){
                                self.fn_updateFileBackupTime(modifiedTime)    
                            }
                            // self.$root.fn_getBusiness(null, null, function(){
                            //   console.log("Get business data after restore complex business.");
                            // });
                        }, 
                        onError: function(error){
                            console.log(error);
                        }
                    }
                );
            },

            fn_toggleDataShare: function(){
                let filterObj = {};
                filterObj.businessId = this.$root.CurrentBusiness.BusinessID;
                filterObj.IsTemporary = this.$root.CurrentBusiness.temporaryBusiness ? true : false;
                let toggleValue = false;
                this.getFilterData("WatchForegroundService", JSON.stringify(toggleValue), filterObj,
                    {
                        onSuccess: function(response){
                            console.log(response);
                        }, 
                        onError: function(error){
                            console.log(error);
                        }
                    }
                );
            },

            fn_updateFileBackupTime: function(modifiedTime){
                let self = this;
                let filterObject = {};
                filterObject.timeMillisecond = modifiedTime;
                filterObject.businessId = this.$root.CurrentBusiness.BusinessID;

                this.postFilterData('UpdateFileBackupTime', null, filterObject, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.$root.fn_getBusiness(null, null, function(){
                                console.log("Get business data after restore complex business.");
                            });
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.showToast('Something went wrong. Try again');
                        }
                    }
                );
            },

            fn_getChunks: function(){
                let self = this;
                this.showLoading("Please wait...");
                this.getData('GetArchivedChunks', this.$root.CurrentBusiness.BusinessID, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            let data = JSON.parse(response);
                            // self.items = data && data.fileList ? data.fileList : [];
                            if(data && data.fileList && data.fileList.length){
                                for(let j=0; j<data.fileList.length; j++){
                                    // converting milliseconds to date time string and appenind to obj
                                    data.fileList[j].createdTimeString = self.$moment(data.fileList[j].createdTime.value).format('DD-MMM-YYYY h:mm a');
                                    self.chunkItems.push(data.fileList[j]); 
                                }
                            }
                            self.chunkItemsDialog = true;
                            
                            self.hideLoading();
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.hideLoading();
                        }
                    }
                );
            },

            fn_deleteAction: function(item, index){
                let createdDate = new Date(item.createdTime.value);
                let currentDate = new Date();
                let difference = parseInt((currentDate - createdDate) / (1000 * 60 * 60 * 24), 10); 
                if(index > 4 && difference > 3){
                    return true;
                }
                else{
                    return false;
                }
            }   
        },

        mounted: function(){
            let self = this;
            setTimeout(function(){
                self.fn_getBackups();
            },300)
            window.js_globals.fn_onBackPress = this.fn_goBack;
        },

        beforeRouteLeave (to, from, next) {
            if(this.chunkItemsDialog){
                this.chunkItemsDialog = false;
                next(false);
            }
            else{
                next();
            }
        }

    }
</script>


// WEBPACK FOOTER //
// src/components/settings/backup_data/databackup_list.vue